import type { ReactElement, ReactNode } from 'react';
import { ButtonRow } from '@ksyos/design-system';
import type { Button, IconButton, Link } from '@frontend/components/elements/common';
import { ProcessStartWizardRowLayout } from './ProcessStartWizardRowLayout';

interface IProcessStartWizardButtonRowLayoutProps {
    action?: ReactElement<typeof Button | typeof Link | typeof IconButton>;
    children: ReactNode;
}

export function ProcessStartWizardButtonRowLayout(props: IProcessStartWizardButtonRowLayoutProps) {
    return (
        <ProcessStartWizardRowLayout action={props.action}>
            <ButtonRow>{props.children}</ButtonRow>
        </ProcessStartWizardRowLayout>
    );
}
